import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const NewTrasnportistas = Loadable(lazy(() => import('views/user/TransportistasView/NewTransportistasView')));

const ListTransportistasUser = Loadable(lazy(() => import('views/user/TransportistasView/ListTransportistasView')));

const TransportistasRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/new-transportistas/:id_transportistas',
            element: <NewTrasnportistas />
        },        
        {
            path: '/user/list-transportistas-view',
            element: <ListTransportistasUser />
        },        
    ]
};

export default TransportistasRoutes;